// @flow

import { type IncomingPayment } from './types';
import { getMerchant } from './get-merchant';

export function getWithholdTaxes(incomingPayment: IncomingPayment): string {
  const merchant = getMerchant(incomingPayment);

  if (!merchant['config']) {
    return 'default';
  }

  return merchant['config']['ebanx_withhold_taxes'] || 'default';
}
